export var APP_LAYOUT_ALIGN;
(function (APP_LAYOUT_ALIGN) {
    APP_LAYOUT_ALIGN["fill"] = "fill";
    APP_LAYOUT_ALIGN["center"] = "center";
    APP_LAYOUT_ALIGN["raised"] = "raised";
})(APP_LAYOUT_ALIGN || (APP_LAYOUT_ALIGN = {}));
//# sourceMappingURL=types.js.map